import React from 'react';
import { FormCardRHF, BaseRHF, InputRHF, FormGroupRHF } from '@cd/rhf';
import * as Yup from 'yup';
import { Box } from '@mui/material';
import { css, useTheme } from '@emotion/react';

//

const FormSchema = Yup.object().shape({
	nameOnCard: Yup.string()
		.min(2, 'Too Short!')
		.max(64, 'Too Long!')
		.required('Required'),
	email: Yup.string()
		.min(2, 'Too Short!')
		.max(80, 'Too Long!')
		.email('Invalid email')
		.required('Required'),
	zip: Yup.string().length(5, 'Must be 5 digits').required('Required')
});

const wrapStyle = css`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
`;

const childrenWrapStyle = css`
	display: flex;
	gap: 8px;
	padding: 0;
	flex-wrap: wrap;
`;

const ZipCodeForm = ({
	defaultFormData,
	setFormData,
	onValidationError,
	onHandleChange
}) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
        <Box sx={wrapStyle}>
            <FormCardRHF
				debug
				mode="all"
				sx={{
					minWidth: '320px',
					boxShadow: 'none',
					padding: 0,
					display: 'flex',
					alignItems: 'center',
					backgroundColor: isDark ? '#171717' : '#fff'
				}}
				childrenWrapStyle={childrenWrapStyle}
				onSubmit={(values, formFns) => {
					setFormData(values);
				}}
				schema={FormSchema}
				title={<span />}
				okButtonTitle={'NEXT'}
				onValidationError={onValidationError}
				onHandleChange={onHandleChange}
				ignoreDirty={true}
				subtitle={<span />}
				defaultValues={defaultFormData}
				hideActions={true}
				triggerNotEmpty={true}>
				<FormGroupRHF name="memberInfo">
					<BaseRHF
						flex={4}
						render={props => (
							<InputRHF
								name="nameOnCard"
								label="NAME ON CARD"
								{...props}
							/>
						)}
						id="nameOnCard"
						key="nameOnCard"
						name="nameOnCard"
					/>
					<BaseRHF
						flex={4}
						render={props => (
							<InputRHF name="email" label="EMAIL" {...props} />
						)}
						id="email"
						key="email"
						name="email"
					/>
					<BaseRHF
						flex={2}
						render={props => (
							<InputRHF name="zip" label="ZIP CODE" {...props} />
						)}
						id="zip"
						key="zip"
						name="zip"
					/>
				</FormGroupRHF>
			</FormCardRHF>
        </Box>
    );
};

export default ZipCodeForm;
